__turbopack_context__.v({
  "buttons": "side-by-side-module-scss-module__6-UWRW__buttons",
  "column": "side-by-side-module-scss-module__6-UWRW__column",
  "column-inner": "side-by-side-module-scss-module__6-UWRW__column-inner",
  "column-inner--small": "side-by-side-module-scss-module__6-UWRW__column-inner--small",
  "column-left": "side-by-side-module-scss-module__6-UWRW__column-left",
  "column-order-0": "side-by-side-module-scss-module__6-UWRW__column-order-0",
  "column-order-2": "side-by-side-module-scss-module__6-UWRW__column-order-2",
  "column-order-mobile-bottom": "side-by-side-module-scss-module__6-UWRW__column-order-mobile-bottom",
  "column-order-mobile-top": "side-by-side-module-scss-module__6-UWRW__column-order-mobile-top",
  "column-right": "side-by-side-module-scss-module__6-UWRW__column-right",
  "compact-spacing": "side-by-side-module-scss-module__6-UWRW__compact-spacing",
  "container": "side-by-side-module-scss-module__6-UWRW__container",
  "copy-column": "side-by-side-module-scss-module__6-UWRW__copy-column",
  "copy-container": "side-by-side-module-scss-module__6-UWRW__copy-container",
  "default-spacing": "side-by-side-module-scss-module__6-UWRW__default-spacing",
  "icon-list-container": "side-by-side-module-scss-module__6-UWRW__icon-list-container",
  "icon-list-item--canary": "side-by-side-module-scss-module__6-UWRW__icon-list-item--canary",
  "icon-list-item--cyanora": "side-by-side-module-scss-module__6-UWRW__icon-list-item--cyanora",
  "icon-list-item--fuscia": "side-by-side-module-scss-module__6-UWRW__icon-list-item--fuscia",
  "icon-list-item--heading": "side-by-side-module-scss-module__6-UWRW__icon-list-item--heading",
  "media": "side-by-side-module-scss-module__6-UWRW__media",
  "row": "side-by-side-module-scss-module__6-UWRW__row",
  "supporting-copy": "side-by-side-module-scss-module__6-UWRW__supporting-copy",
  "tiny-spacing": "side-by-side-module-scss-module__6-UWRW__tiny-spacing",
});
